<template>
    <ui-card 
        icon="fal fa-user-lock" 
        title="Permissões - Alteração de Etapa e Status" 
        :selection-bar="true"
    >
        <template #body>

            <div class="header-body-container">
                <span>Selecione os usuários com permissão para <span class="text-weight">alterar etapa e status</span> sem seguir as regras.</span>
            </div>
            <div class="diviser" />            
            
            <div class="content">
                <ui-transfer-list 
                    :search-origin.sync="searchOrigin"
                    :search-target.sync="searchTarget"
                    :origin-message="'Sem permissão'"
                    :target-message="'Com permissão'"
                    :search-message="'Buscar Usuário'"
                    :to-right-action="transferSelectedUsers"
                    :to-left-action="transferSelectedUsersWithPermission"
                    :actions-disable="loadingUserWithPermission || loadingUserWithoutPermission || loading"
                    :active-right-action="selectedUsers.length > 0"                
                    :active-left-action="selectedUsersWithPermission.length > 0"     
                    :is-pagination="true"     
                    padding-container="0px 30px 45px 30px"
                    title-padding="13.5px 12px 12px 15px" 
                    title-font-size="13px" 
                    container-height="370px"      
                >
                    <template #sourceList>
                        <perfect-scrollbar
                            v-if="!loadingUserWithoutPermission"
                            ref="originScrollbar"
                            class="card-container scroll-container"
                            @ps-y-reach-end="onOriginScrollEnd"
                        >
                            <div>
                                <div v-for="user in users" :key="user.id" @click="onSelectUser(user)">
                                    <ui-user-card
                                        :user="user"
                                        :is-selected="selectedUsers.some(u => u.id === user.id)"
                                    />
                                </div>
                            </div>

                            <div
                                v-if="loadingMoreWithoutPermission"
                                class="loading-container"
                            >
                                <ui-load-indicator h="24"/>
                            </div>
                        </perfect-scrollbar>

                        <div v-else  class="loading-container">
                            <ui-load-indicator bg-color="#e7e9f4" color="#69D296" :h="50" :stroke="8" />
                        </div>
                    </template>
                    
                    <template #targetList>
                        <perfect-scrollbar
                            v-if="!loadingUserWithPermission"
                            ref="targetScrollbar"
                            class="card-container scroll-container"
                            @ps-y-reach-end="onTargetScrollEnd"
                        >
                            <div>
                                <div 
                                    v-for="user in usersWithPermission" 
                                    :key="user.id" 
                                    @click="onSelectUsersWithPermission(user)"
                                >
                                    <ui-user-card
                                        :user="user"
                                        :is-selected="selectedUsersWithPermission.some(u => u.id === user.id)"
                                    />
                                </div>
                            </div>

                            <div
                                v-if="loadingMoreWithPermission"
                                class="loading-container"
                            >
                                <ui-load-indicator h="24"/>
                            </div>
                        </perfect-scrollbar>
                        <div v-else  class="loading-container">
                            <ui-load-indicator bg-color="#e7e9f4" color="#69D296" :h="50" :stroke="8" />
                        </div>
                    </template>
                </ui-transfer-list>  
                
            </div>
        </template>
        <template #selectionBar>
            <div >
                <div class="diviser" />
                <div class="bulk-mass-container">
                    <div class="switch-all-users">
                        <ui-switch
                            v-model="checkedAllUsers"
                            :checked="checkedAllUsers"
                            design="xs"
                        />
                        <span>Permitir alteração de etapa e status em massa.</span>
                    </div>
                </div>
            </div>
        </template>
        <template  #fl> 
            <div class="footer-content">
                <span  v-if="howManySelecteds > 0" class="footer-text-weight">{{ howManySelecteds }} usuários</span> <span v-if="howManySelecteds > 0" class="footer-text">selecionados</span>
            </div>
        </template>
        <template #fr>
            <ui-button design="md success" :loading="loading" :disabled="!canSubmit" @click="submit">Salvar</ui-button>
        </template>
    </ui-card>
</template>
<script>
import { uiLoadIndicator, uiTransferList } from '@/components/ui';
import { uiUserCard } from '@/components/ui-facilita/funnel';
import { uiButton } from '@/components/ui/buttons';
import { uiCard } from '@/components/ui/cards';
import { uiSwitch } from '@/components/ui/form';
import { funnel } from '@/services/axios';

    export default {
        name: 'configuration-funnel-permissions',

        components: {
            uiButton,
            uiCard,
            uiUserCard,
            uiTransferList,
            uiLoadIndicator,
            uiSwitch
        },


        data() {
            return {
                users: [],
                selectedUsers: [], // usuarios selecionados visualmente na tela
                usersWithPermission: [], 
                selectedUsersWithPermission: [], // usuarios com permissao selecionados visualmente na tela
                loadingUser: false,
                loading: false,
                defaultForm: [],
                searchOrigin: '',
                searchTarget: '', 
                defaultCheckedAllUsers: false,
                checkedAllUsers: false,
                // Controles de paginação (SEM permissão):
                currentPageWithout: 1,
                lastPageWithout: 1,

                // Controles de paginação (COM permissão):
                currentPageWith: 1,
                lastPageWith: 1,

                loadingUserWithoutPermission: false, 
                loadingMoreWithoutPermission: false,
                loadingUserWithPermission: false,
                loadingMoreWithPermission: false
            }
        },

        computed: {
            howManySelecteds() {
                return this.selectedUsers.length + this.selectedUsersWithPermission.length
            },

            canSubmit() {
                const sameArrays = JSON.stringify(this.defaultForm) === JSON.stringify(this.usersWithPermission)
                const sameCheckedAllUsers = this.checkedAllUsers === this.defaultCheckedAllUsers
                return !(sameArrays && sameCheckedAllUsers)
                    && this.usersWithPermission
                    && !this.loadingUserWithPermission
                    && !this.loadingUserWithoutPermission
            },
        },
        watch: {
          searchOrigin(newVal) {
            this.currentPageWithout = 1;
            this.fetchUsersWithoutPermissions(1, newVal || "");
          },
      
          searchTarget(newVal) {
            this.currentPageWith = 1;
            this.fetchUsersWithPermissions(1, newVal || "");
          }
        },

        async created() {
            this.fetchUsersWithPermissions(1)
            this.fetchUsersWithoutPermissions(1)
            
            const userLogged = JSON.parse(localStorage.getItem('fac_user_logged') || '{}');

              if (userLogged?.config_permissions?.bulkActionMoveDeal !== undefined) {
                this.checkedAllUsers = userLogged.config_permissions.bulkActionMoveDeal === 1;
              }

              this.defaultCheckedAllUsers = this.checkedAllUsers
        },

        methods: {
			async fetchUsersWithoutPermissions(page = 1, search = "") {
               if (page === 1) {
                   this.loadingUserWithoutPermission = true;
               } else {
                   this.loadingMoreWithoutPermission = true;
               }

               funnel.getUsersWithPermissions({
                    page,
                    perPage: 15,
                    search,
                    withPermission: 0
                })
                .then(({ data }) => {
                    const response = data.data.data.map(user => ({
                        id: user.id,
                        name: user.first_name,
                        group: this.renderGroups(user.groups?.[0]?.name),
                        photo: user.photo || user.cover
                    }));
                
                    if (page === 1) {
                        this.users = response;
                    } else {
                        this.users = [...this.users, ...response];
                    }
                
                    this.currentPageWithout = data.data.current_page;
                    this.lastPageWithout = data.data.lastPage;
                })
                .catch((error) => {
                    if (error?.data?.msg) this.$toastr.e(error.data.msg);
                })
                .finally(() => {
                    if (page === 1) {
                        this.loadingUserWithoutPermission = false;
                    } else {
                        this.loadingMoreWithoutPermission = false;
                    }
                });

            },


            fetchUsersWithPermissions(page = 1, search = "") {
                if (page === 1) {
                    this.loadingUserWithPermission = true;
                } else {
                    this.loadingMoreWithPermission = true;
                }
            
                funnel.getUsersWithPermissions({
                    page,
                    perPage: 15,
                    search,
                    withPermission: 1
                })
                .then(({ data }) => {
                    const response = data.data.data.map(user => ({
                        id: user.id,
                        name: user.first_name,
                        group: this.renderGroups(user.groups?.[0]?.name),
                        photo: user.photo || user.cover
                    }));
                
                    if (page === 1) {
                        this.usersWithPermission = response;
                    } else {
                        this.usersWithPermission = [...this.usersWithPermission, ...response];
                    }
                
                    this.currentPageWith = data.data.current_page;
                    this.lastPageWith = data.data.lastPage;
                
                    if (page === 1) {
                        this.defaultForm = [...this.usersWithPermission];
                    }
                })
                .catch((error) => {
                    if (error?.data?.msg) this.$toastr.e(error.data.msg);
                })
                .finally(() => {
                    if (page === 1) {
                        this.loadingUserWithPermission = false;
                    } else {
                        this.loadingMoreWithPermission = false;
                    }
                });
            },

            onSelectUser(user) {
                const isUserSelected = this.selectedUsers.some(userSelected => userSelected.id === user.id);
                if (isUserSelected) {
                    this.selectedUsers = this.selectedUsers.filter(userSelected => userSelected.id !== user.id);
                } else {
                    this.selectedUsers.push(user);
                    this.selectedUsersWithPermission = []
                }
            },

            onSelectUsersWithPermission(userWithPermission) {
                const isUserSelected = this.selectedUsersWithPermission.some(userSelected => userSelected.id === userWithPermission.id);
                if (isUserSelected) {
                    this.selectedUsersWithPermission = this.selectedUsersWithPermission.filter(userSelected => userSelected.id !== userWithPermission.id);
                } else {
                    this.selectedUsersWithPermission.push(userWithPermission);
                    this.selectedUsers = []
                }
            },
  
            // Move usuários selecionados para a lista COM permissão
            transferSelectedUsers() {
                this.usersWithPermission = [
                  ...this.selectedUsers,
                  ...this.usersWithPermission
                ];

                // Remove esses usuários do array original (sem permissão)
                this.users = this.users.filter(
                  user => !this.selectedUsers.some(sel => sel.id === user.id)
                );

                // Limpa a seleção
                this.selectedUsers = [];
              },
      
          // Move usuários selecionados para a lista SEM permissão
          transferSelectedUsersWithPermission() {
            this.users = [
              ...this.selectedUsersWithPermission,
              ...this.users
            ];
        
            // Remove esses usuários do array original (com permissão)
            this.usersWithPermission = this.usersWithPermission.filter(
              user => !this.selectedUsersWithPermission.some(sel => sel.id === user.id)
            );
        
            // Limpa a seleção
            this.selectedUsersWithPermission = [];
          },
            onOriginScrollEnd() {
                if (this.currentPageWithout < this.lastPageWithout) {
                    this.fetchUsersWithoutPermissions(this.currentPageWithout + 1, this.searchOrigin);
                }
            },

            onTargetScrollEnd() {
                if (this.currentPageWith < this.lastPageWith) {
                    this.fetchUsersWithPermissions(this.currentPageWith + 1, this.searchTarget);
                }
            },

            async submit() {
                if (this.loading) return;
                this.loading = true;
                this.selectedUsersWithPermission = []
                this.selectedUsersWithoutPermission = []

                Promise.all([
                    funnel.updateV2("configurations/privilegeOverRules", "", {
                        users: this.usersWithPermission.map(user => user.id)
                    }),
                    funnel.updateAllowBulkStageStatusChange({
                        active: this.checkedAllUsers
                    })
                ])
                .then(() => {
                    this.$toastr.s("Permissões atualizadas com sucesso!")
                    
                    this.searchOrigin = ''
                    this.searchTarget = ''
                    this.defaultForm = this.usersWithPermission
                    this.defaultCheckedAllUsers = this.checkedAllUsers;
                    // atualiza a permissão no storage
                    const userLogged = JSON.parse(localStorage.getItem('fac_user_logged') || '{}');
                    // Verifique se existe a estrutura de permissions no objeto
                    if (!userLogged.config_permissions || Array.isArray(userLogged.config_permissions)) {
                        userLogged.config_permissions = {}
                    }

                    userLogged.config_permissions.userPrivilegedMoveDeal = this.usersWithPermission.some(user => user.id === userLogged.id) ? 1 : 0
                    userLogged.config_permissions.bulkActionMoveDeal = this.checkedAllUsers ? 1 : 0

                    localStorage.setItem('fac_user_logged', JSON.stringify(userLogged))
                    
                })
                .catch(error => {
                    if (error && error?.msg) this.$toastr.e(error.msg)
                })
                .finally(() => {
                    this.loading = false;
                })
            },

            // Função para montar os nomes dos grupos dos usuários
            renderGroups(groupName) {
                const groupStrategies = {
                manager: 'Gerente',
                collaborator: 'Colaborador',
                admin: 'Administrador',
                broker: 'Corretor',
                supervisor: 'Supervisor',
                };

                return groupStrategies[groupName] || groupName
            },
		}
    }
</script>

<style lang="stylus" scoped>
    @import './styles.styl'
</style>
